import type { PropsWithChildren } from 'react';
import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import { PortalNestProvider } from '@elfsight/widget-modal';
import {
  CustomCSS,
  createCustomCSSPrefixClassName,
  EmbedRoot,
  ShadowEmbedRoot
} from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { meta } from './meta';
import type { BeforeAndAfterSliderSettings } from './types';
import { Widget } from './widget/Widget';

export function BeforeAndAfterSlider(_settings: BeforeAndAfterSliderSettings) {
  return (
    <Providers>
      <Widget />
    </Providers>
  );
}

function Providers({ children }: PropsWithChildren) {
  const {
    customCSS,
    customJS,
    editMode,
    renderThumbnailMode,
    widgetId,
    _shadowDOMDisabled
  } = useSettings();

  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.alias,
    widgetId
  );

  useDefineAPISchema();
  useCustomJS(customJS, editMode || renderThumbnailMode);

  if (_shadowDOMDisabled === true) {
    return (
      <>
        <CustomCSS
          customCSS={customCSS}
          prefixClassName={customCSSPrefixClassName}
        />
        <EmbedRoot customCSSClassName={customCSSPrefixClassName}>
          {children}
        </EmbedRoot>
      </>
    );
  }

  return (
    <ShadowEmbedRoot customCSS={customCSS}>
      <PortalNestProvider customCSSClassName={customCSSPrefixClassName}>
        {children}
      </PortalNestProvider>
    </ShadowEmbedRoot>
  );
}
